export const AH_VERIFICATION_LIST_SUCCESS = "AH_VERIFICATION_LIST_SUCCESS";

export const GET_VERIFIED_AH_LIST_SUCCESS = "GET_VERIFIED_AH_LIST_SUCCESS";

export const GET_VERIFIED_AH_DETAIL_SUCCESS = "GET_VERIFIED_AH_DETAIL_SUCCESS";

export const SET_VERIFICATION_JOB_LOADING = "SET_VERIFICATION_JOB_LOADING";

export const SET_FILTER_DATA = "SET_FILTER_DATA";

export const SET_SYNC_DETAILS_FILTER_DATA = "SET_SYNC_DETAILS_FILTER_DATA";

export const SET_ACTIVE_SYNC_DETAILS_DATA = "SET_ACTIVE_SYNC_DETAILS_DATA";
